import React from 'react';
import type { SubjectRangeAnalysis } from 'venn-api';
import { capitalize } from 'lodash';
import type { FundToBulkProxy } from '../../types';
import type { LayeredProxyConfiguration } from '../proxy-types';
import { formatDateByFrequency } from '../../../../manage-data/utils';
import { Icon } from 'venn-ui-kit';
import { ExistingProxySection } from './ExistingProxyDisplay';
import { Separator } from '@/components/ui/separator';
import type { BulkPickerDetailedProxyMetadata } from '../../../../hooks/useProxyDataQuery';

export const SingleInvestmentInfo = ({
  investment,
  proxyConfiguration,
  proxyData,
  rangeData,
}: {
  investment: FundToBulkProxy;
  proxyConfiguration: LayeredProxyConfiguration;
  proxyData: BulkPickerDetailedProxyMetadata | undefined;
  rangeData: SubjectRangeAnalysis | undefined;
}) => {
  const startRange = rangeData?.start;
  const endRange = rangeData?.end;

  const unproxiedFrequency = proxyData?.unproxiedFrequency ?? rangeData?.frequency;
  const proxiedFrequency = proxyData?.proxiedFrequency ?? rangeData?.frequency;

  return (
    <div>
      <div className="flex gap-[18px] pb-[16px] items-start justify-between">
        <div className="flex flex-col gap-[6px] flex-grow">
          <div className="font-bold">Asset Name</div>
          {investment.name}
        </div>
        <div className="flex gap-[18px]">
          <ExistingProxySection proxyConfiguration={proxyConfiguration} />
          <div className="flex flex-col gap-[6px] whitespace-nowrap">
            <div className="font-bold">Frequency</div>
            {proxiedFrequency !== unproxiedFrequency ? (
              <span>
                {capitalize(unproxiedFrequency)} <Icon type="arrow-right" className="inline text-venn-grey-60" />{' '}
                {capitalize(proxiedFrequency)}
              </span>
            ) : (
              capitalize(unproxiedFrequency)
            )}
          </div>
          {startRange && endRange && (
            <div className="flex flex-col gap-[6px] whitespace-nowrap">
              <div className="font-bold">Available Dates</div>
              {formatDateByFrequency(startRange, investment.returnFrequency)} -{' '}
              {formatDateByFrequency(endRange, investment.returnFrequency)}
            </div>
          )}
        </div>
      </div>
      <Separator className="bg-venn-grey-30" />
    </div>
  );
};
